class GiftFinder extends HTMLElement {
  constructor() {
    super();
    this.answers = {};
    this.steps = this.querySelectorAll('.gift-finder__step');

    this.querySelector('.gift-finder__start').addEventListener('click', () => this.goToStep('q1'));

    this.querySelectorAll('.gift-finder__option').forEach((button) => {
      button.addEventListener('click', () => this.handleAnswer(button));
    });

    const retakeButton = this.querySelector('.gift-finder__retake');
    if (retakeButton) {
      retakeButton.addEventListener('click', () => this.reset());
    }
  }

  handleAnswer(button) {
    const question = button.dataset.answer;
    const value = button.dataset.value;
    this.answers[question] = value;

    if (question === 'recipient') {
      this.goToStep('q2');
    } else if (question === 'occasion') {
      this.showResult();
    }
  }

  showResult() {
    const key = this.answers.recipient + '-' + this.answers.occasion;
    const cards = this.querySelectorAll('.gift-finder__result-card');
    cards.forEach((card) => {
      const keys = (card.dataset.keys || '').split(' ');
      if (keys.indexOf(key) !== -1) {
        card.removeAttribute('hidden');
      } else {
        card.setAttribute('hidden', '');
      }
    });
    this.goToStep('result');
  }

  reset() {
    this.answers = {};
    this.goToStep('intro');
  }

  goToStep(stepName) {
    this.steps.forEach((step) => {
      step.classList.toggle('gift-finder__step--active', step.dataset.step === stepName);
    });
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

customElements.define('gift-finder', GiftFinder);
